/**
 * Author: Lakshman Veti
 * Type: Service
 * Objective: Serve common functionality for auth/login
 * Associated Route/Usage: "#/login"
 */

import config from "../config";
import commonService from "./commonService";
import { authHeader } from "../helpers/common";
import CONSTANTS from "../data/constants";

const mockUsers = [
  {
    username: "512019120001",
    password: "s2HVZKJPV6s=",
  },
];

const role = "vendor";

// const userRights = {
//     1:{ // Back Office
//         pr: ['create','edit','view'],
//         sq: ['create','edit','view'],
//         quote: ['compare'],
//         po: ['create','edit','view'],
//         wo: ['create','edit','view'],
//         wor: ['create','edit','view'],
//         woq: ['create','edit','view']
//     },
//     2:{ // Vessel
//         pr: ['create','edit','view'],
//         wor: ['create','edit','view'],
//         //wo: ['create','edit','view']
//        // sq: ['create','edit','view'],
//         //po: ['create','edit','view']
//         quote: ['compare']
//     },
//     3:{ // Vendor
//       sq: ['create','edit','view'],
//       po: ['create','edit','view'],
//       wo: ['create','edit','view'],
//       //wor: ['create','edit','view'],
//       woq: ['create','edit','view']
//     }
// }

const userRights = {
  1: {
    // Back Office
    pr: ["create", "edit", "view"],
    sq: ["create", "edit", "view"],
    quote: ["compare"],
    po: ["create", "edit", "view"],
    do: ["create", "edit", "view"],
    wo: ["create", "edit", "view"],
    wdo: ["create", "edit", "view"],
    wor: ["create", "edit", "view"],
    woq: ["create", "edit", "view"],
    mpl: ["create", "edit", "view"],
    ecc: ["create", "edit", "view"],
    evc: ["create", "edit", "view"],
    "master-category": ["create", "edit", "view"],
    "master-impacodes": ["create", "edit", "view"],
    "master-impacategory": ["create", "edit", "view"],
    "batch-process": ["create", "edit", "view"],
    "credit-term": ["create", "edit", "view"],
    "vendor-list": ["create", "edit", "view"],
    "emloyee-category": ["create", "edit", "view"],
    "employee-list": ["create", "edit", "view"],
    "gST-list": ["create", "edit", "view"],
    "uom-list": ["create", "edit", "view"],
    "vesselDepartment-list": ["create", "edit", "view"],
    "port-list": ["create", "edit", "view"],
    "vessel-list": ["create", "edit", "view"],
    "mainCode-list": ["create", "edit", "view"],
    "mpl-quotation": ["create", "edit", "view"],
    "approval-center": ["create", "edit", "view"],
    "spareParts-list": ["create", "edit", "view"],
    dashboard: ['view'],
    homePage: ['view'],
    "rfq": ["view", "create"],
    // "r&d": ["create", "edit", "view"],
    "user-module": ["create", "edit", "view"],
    "accessRights": ["create", "edit", "view"],
    unauthorized: ['view'],
    "master-Screen":["create", "edit", "view"],
    "equipment-list": ["create", "edit", "view"],
    poAnalysis: ["create", "edit", "view"],
    tempPage: ["create", "edit", "view"],
    columnChooser: ["create", "edit", "view"],
  },
  2: {
    // Vessel
    pr: ["create", "edit", "view"],
    wor: ["create", "edit", "view"],
    do: ["create", "edit", "view"],
    wdo: ["create", "edit", "view"],
    "vessel-list": ["create", "edit", "view"],// only for SubRoleId = 203
    "mpl-quotation": ["create", "edit", "view"],
    "master-impacodes": ["create", "edit", "view"],
    dashboard: ['view'],
    homePage: ['view'],
    unauthorized: ['view'],
    //approval_center: ["create", "edit", "view"],
  },
  3: {
    // Vendor
    sq: ["create", "edit", "view"],
    //po: ["create", "edit", "view"],
    po: ["view"],
    wo: ["view"],
    //wo: ["create", "edit", "view"],
    do: ["create", "edit", "view"],
    wdo: ["create", "edit", "view"],
    woq: ["create", "edit", "view"],
    dashboard: ['view'],
    homePage: ['view'],
    unauthorized: ['view'],
  },
  4: {
    do: ["create", "edit", "view"],
    wdo: ["create", "edit", "view"],
    dashboard: ['view'],
    homePage: ['view'],
    unauthorized: ['view'],
  },
};

const authService = {
  login,
  changePassword,
  logout,
  clear,
  hasLoggedIn,
  throwBack,
  getUser,
  getAll,
  validateRoute,
  getOAuthToken,
  redirectToUnathorized,
  redirectToUnathorizedPage,
  getSystemSettings,
};

export default authService;

/**
 * User login method
 * @userCode : string
 * @password : string
 * @remeber  : boolean
 */
function login(userCode, password, remember) {
  var usr = getMockUser(userCode);
  if (usr) password = usr.password;
  // console.log(usr)
  // if(usr){
  //     localStorage.setItem('user', JSON.stringify(usr));
  //     window.location = '#/dashboard';
  //     return true;
  // }else return false;

  return commonService.restCall({
    // url: `${config.apiUrl}${config.snapshot.master}/login/validateUser`,
    url: `${config.apiUrl}${config.snapshot.master}/login/oauth2ValidateUser`,
    method: "POST",
    data: { userCode, password },
  });
}

function changePassword(UserCode, oldPassword, newPassword, confirmPassword) {
  var user = getMockUser(UserCode);
  if (user) oldPassword = user.password;
  return commonService.restCall({
    // url: `${config.apiUrl}${config.snapshot.login}/login/changePassword`,
    url: `${config.apiUrl}${config.snapshot.master}/login/changePassword`,
    method: "POST",
    data: {
      "userCode": UserCode,
      "currentPassword": oldPassword,
      "newPassword": newPassword,
      "confirmPassword": confirmPassword
    },
  })
}
function getOAuthToken(userCode, password) {
  const formData = new FormData();
  formData.append("username", userCode);
  formData.append("password", password);
  formData.append("grant_type", "password");
  const requestOptions = {
    method: "POST",
    headers: commonService.getJsonHeaders({}),
    body: formData,
    redirect: "follow",
  };
  return fetch(`${config.snapshot.oauth}`, requestOptions)
    .then(commonService.handleResponse)
    .then((data) => {
      // console.log('response..'+data);
      return data;
    });
}
/**
 * User logout method, removes user object from browser localstorage and reloads page
 * @void
 */
function logout() {
  // remove user from local storage to log user out
  localStorage.clear();
  // sessionStorage.clear(); // 15/06/23(User Req to remove MultiTab Login)
  window.location = "#/login";
}

/**
 * Removes user object from browser localstorage
 * @void
 */
function clear() {
  // remove user from local storage to log user out
  // sessionStorage.removeItem("user"); // 15/06/23(User Req to remove MultiTab Login)
  localStorage.removeItem("user");
}

/**
 * Returns flag if the user is already logged in
 * @void
 */
function hasLoggedIn() {
  // return sessionStorage.getItem("user") ? true : false;// 15/06/23(User Req to remove MultiTab Login)
  return localStorage.getItem("user") ? true : false;
}

/**
 * Removes user object from browser localstorage and redirects to login page
 * @void
 */
function throwBack(hash) {
  // if (!sessionStorage.getItem("user")) {// 15/06/23(User Req to remove MultiTab Login)
    if (!localStorage.getItem("user")) {
    localStorage.setItem("reRoute", hash);
    window.location = "#/login";
    return false;
  }
  return true;
}

function getAll() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(`${config.apiUrl}users`, requestOptions).then(
    commonService.handleResponse
  );
}

/**
 * User login bypass method to validate user locally
 * @username : string
 */
function getMockUser(username) {
  var usr = null;
  for (var i in mockUsers) {
    if (mockUsers[i].username === username) {
      usr = mockUsers[i];
      break;
    }
  }
  return usr;
}

/**
 * get user object from localstorage
 */
function getUser() {
  // if (sessionStorage.getItem("user")) { // 15/06/23(User Req to remove MultiTab Login)
  //   return JSON.parse(sessionStorage.getItem("user")).data;
  // }
  if (localStorage.getItem("user")) {
    return JSON.parse(localStorage.getItem("user")).data;
  }
  return null;
}

/**
 * get user object from localstorage
 */
// function getUserRole() {
//   if (localStorage.getItem("user")) {
//     return JSON.parse(localStorage.getItem("user")).data.role;
//   }
//   //return userRights.vendor;
// }

/**
 * validate the requested route is available the given role
 */
function validateRoute(hash) {
  var urlSplit = hash.split("/");
  if (urlSplit.join("").indexOf("login") != -1) return;

  if (!authService.throwBack(hash)) {
    return;
  };
  const role = authService.getUser();
  urlSplit[1] = (urlSplit[1]?.includes("rfq?reqNo") ||urlSplit[1]?.includes("rfq?wreqNo")) ? "rfq" : urlSplit[1];
  urlSplit[1] = (urlSplit[1]?.includes("unauthorized?isFrom")) ? "unauthorized" :urlSplit[1]
  urlSplit[1] = (urlSplit[1]?.includes("master-Screen?")) ? "master-Screen" :urlSplit[1]
  if (urlSplit.length >= 2 && role) {
    if (
      userRights[role.roleId] &&
      userRights[role.roleId][urlSplit[1]] &&
      userRights[role.roleId][urlSplit[1]].includes(urlSplit[2]) &&
      role?.userId != "92104003" &&
      role?.userId != "92104002"
    ) {
      // console.log(userRights[role.roleId][urlSplit[1]]);
    } else if (
      userRights[role.roleId] &&
      !userRights[role.roleId][urlSplit[1]] && urlSplit[1] !== ""
    ) {
      window.location = "/#/page401";
    } else if (
      (role?.userId == "92104003" || role?.userId == "92104002") &&
      userRights[role.roleId] &&
      !(urlSplit[1] == "do" || urlSplit[1] == "wdo")
    ) {
      window.location = "/#/page401";
    }
  }
  //userRights[role].includes()
}

function redirectToUnathorized(roleId, objectId, data,subRoleId) {
  switch (roleId) {
    case "2":
    case 2:
      if(subRoleId == CONSTANTS.SUBROLEID.ALL_VESSELS){

      }else if (objectId != data.bargeId) {
        window.location = "/#/page401";
      }
      break;
    case "3":
    case 3:
      if (objectId != data.vendorId) {
        window.location = "/#/page401";
      }
      break;
  }
}

function redirectToUnathorizedPage(roleId, objectId, vendorId) {
  switch (roleId) {
    // case "2":
    // case 2:
    //   if (objectId != data?.bargeId) {
    //     window.location = "/#/page401";
    //   }
    //   break;
    case "3":
    case 3:
      if (objectId != vendorId) {
        window.location = "/#/page401";
      }
      break;
  }
}

function getSystemSettings() {
  const url = `${config.apiUrl}${config.snapshot.master}${config.snapshot.systemSettings}`
      return commonService.restCall({
        url,
        method:'GET',
        headers:[{"moduleId":0},{"transactionId": 0},{"CategoryId": "0"}]
    });
}